export const useLogFacetStyle = () => {
  const mainFacetTitle = {
    width: '170px',
    paddingRight: '8px',
  };
  const subFacetTitle = {
    width: '150px',
    wordWrap: 'break-word',
    paddingRight: '8px',
  } as const;
  const logFacet = {
    width: '320px',
    height: '100%',
    overflowY: 'auto',
  } as const;
  return {
    mainFacetTitle,
    subFacetTitle,
    logFacet,
  };
};
